module.exports = __webpack_public_path__ + "e12aa2e852eb0c94178b42b721d00af7.svg";